import { AnalyticsBrowser } from '@segment/analytics-next';

import { createContext, useContext } from 'react';

import { SegmentInfo, useSegmentAnalytics } from './hooks/useSegmentAnalytics';

const SegmentAnalyticsContext = createContext<{
  analytics?: AnalyticsBrowser;
  data?: SegmentInfo;
} | null>(null);
const SegmentAnalyticsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const segment = useSegmentAnalytics();

  return (
    <SegmentAnalyticsContext.Provider value={segment}>
      {children}
    </SegmentAnalyticsContext.Provider>
  );
};

const useSegmentAnalyticsContext = () => {
  const context = useContext(SegmentAnalyticsContext);
  return context ?? {};
};

export {
  SegmentAnalyticsContext,
  SegmentAnalyticsProvider,
  useSegmentAnalyticsContext,
};
